import React from 'react';

import { Icon } from '@sravni/react-design-system';
import { Filter } from '@sravni/react-icons';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { ITagsListOptions } from '../../../types/tags';

import { Tag } from './Tag';
import { TagsModal } from './TagsModal';

interface ITagSelectionProps {
  isButtonVisible?: boolean;
  isButtonDisabled?: boolean;
  error?: boolean;
  tagsList: ITagsListOptions;
  activeTags: string[];
  handleTagChange: (value, label) => void;
  modalButtonName?: string;
}

export const TagsSelection: React.FC<ITagSelectionProps> = ({
  isButtonVisible = true,
  isButtonDisabled = false,
  error = false,
  tagsList,
  activeTags = [],
  handleTagChange,
  modalButtonName = 'Показать',
}) => {
  const isMobile = useIsMobile();
  const [isDialogVisible, setDialogVisible] = useBoolean(false);

  if (!isButtonVisible) return null;

  return (
    <>
      <Tag closable={false} error={error} disabled={isButtonDisabled} onClick={setDialogVisible.on}>
        {isMobile ? 'Все' : 'Все форматы'} <Icon icon={<Filter />} />
      </Tag>
      <TagsModal
        isDialogVisible={isDialogVisible}
        handleModalClose={setDialogVisible.off}
        activeTags={activeTags}
        tagsList={tagsList}
        handleTagChange={handleTagChange}
        modalButtonName={modalButtonName}
      />
    </>
  );
};
